import React from 'react'
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutline';

const CustomInputHorizontal1 = (props) => {
    const {
        title,
        required,
        inputType,
        handleInputChange = () => { }, // Default value to an empty function
        name,
        id,
        isError,
        isSuccess,
        message,
        minValue,
        maxValue,
        readOnly,
        value,
        placeholder,
        disabled,
        autoFocus,
        className,
        labelEnable = true
    } = props;

    return (
        <div className="pt-[10px] grid grid-cols-12 gap-y-2 md:gap-y-0">
            <div className='col-span-2 md:col-span-2 flex items-center'>
                <label className="block text-sm">
                    {title}
                    {required
                        ?
                        <span className='text-[#EF4444] ml-1'>*</span>
                        :
                        <></>
                    }
                </label>
            </div>
            <div className="relative col-span-10 md:col-span-10">
                <input
                    autoFocus={autoFocus}
                    type={inputType}
                    name={name}
                    id={id}
                    className={`placeholder-400 form-control focus:!border-[#E5E7EB] focus:!outline-none focus:!shadow-none focus-visible:!outline-none active:!outline-none ${className} ${isError && message ? "invalid" : ""} 
                    ${isSuccess ? "success" : ""}
                    ${(isError && message) || isSuccess ? "pr-12" : ""}`
                    }
                    {...(inputType === "number" ? { min: minValue, max: maxValue } : {})}

                    readOnly={readOnly}
                    disabled={disabled}
                    onChange={handleInputChange}
                    value={value}
                    placeholder={placeholder} />

                {isSuccess && (
                    <span className='absolute inset-y-0 right-0 px-3 py-3'>
                        <DoneIcon fontSize='small' className='text-green-500' />
                    </span>
                )}
                {isError && message && (
                    <span className='absolute inset-y-0 right-0 px-3 py-3'>
                        <ErrorIcon fontSize='small' className='text-red-500' />
                    </span>
                )}
            </div>
            <div className='md:col-start-5 md:col-span-8 col-span-12'>
                {isError && (
                    <p className='text-[14px] text-red-500 mt-1'>{message}</p>
                )}
            </div>
        </div>
    )
}

export default CustomInputHorizontal1